import { DashboardList } from "@twii/bored/lib/model/DashboardList";
import { StorageServiceContext } from "@twii/bored/lib/service/StorageServiceContext";
import { ComponentFactory } from "@twii/bored/lib/model/ComponentFactory";
import { TransientStorageService } from "@twii/core/lib/service/TransientStorageService";
import { LoggingStorageService } from "@twii/core/lib/service/LoggingStorageService";
import { AppRouter } from "../AppRouter";

const storageKey = "sample-dashboard-list";

const storageService = new LoggingStorageService({
    prefix: "sampleDashboardStorage",
    target: new TransientStorageService()
})

const DashboardListStore = new DashboardList();
DashboardListStore.setRouter(AppRouter);
DashboardListStore.loader = () => {
    return storageService.getItem(storageKey);
};
DashboardListStore.saver = (data) => {
    return storageService.setItem(storageKey, data);
};
DashboardListStore.addApp = { title: "Samples", path: "/samples" };
DashboardListStore.componentFactory = ComponentFactory;

export { DashboardListStore }